import defo from "@icelab/defo";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-toward-subtle.css";

import "@app/builds/tailwind.css";
import "../css/app.css";

import Alpine from "@alpinejs/csp";
import sort from "@alpinejs/sort";
import sticky from "alpinejs-sticky";
import Clipboard from "@ryangjchandler/alpine-clipboard";

import "htmx.org";

import confirmLink from "./components/confirm_link";
import confirmPublish from "./components/confirm_publish";
import autosave from "./components/autosave";
import postEditor from "./components/post_editor";
import slugifier from "./components/slugifier";
import { mediaManager, mediaSelection } from "./components/media_manager";
import addRemove from "./components/add_remove";
import sidebarManager from "./components/sidebar_manager";
import reactionButton from "./components/reaction_button";

import { views, applyFormattingToPreBlocks } from "./views/index";

Alpine.plugin(sort);
Alpine.plugin(sticky);
Alpine.plugin(Clipboard);

Alpine.data("confirmLink", confirmLink);
Alpine.data("confirmPublish", confirmPublish);
Alpine.data("autosave", autosave);
Alpine.data("postEditor", postEditor);
Alpine.data("slugifier", slugifier);
Alpine.data("mediaManager", mediaManager);
Alpine.data("mediaSelection", mediaSelection);
Alpine.data("addRemove", addRemove);
Alpine.data("sidebarManager", sidebarManager);
Alpine.data("reactionButton", reactionButton);

// @ts-ignore
window.Alpine = Alpine;
Alpine.start();

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    defo({ views });

    applyFormattingToPreBlocks();

    Alpine.magic("clipboard", () => {
      return (subject: string) => navigator.clipboard.writeText(subject);
    });

    const changeEvent = new Event("change");
    document.body.addEventListener("htmx:afterSwap", (event) => {
      // @ts-ignore
      if (event.detail.target.id === "bookmark-url") {
        const input = document.querySelector("#bookmark-name") as HTMLInputElement | null;
        // @ts-ignore
        if (input && input.value === "") {
          // @ts-ignore
          input.value = JSON.parse(event.detail.xhr.response).title;
          input.dispatchEvent(changeEvent);
        }
      }
    });
  });
})();
